import RoomOverviews from '../components/RoomOverviews.jsx';

const Rooms = () => {
  return (
    <div>
      <RoomOverviews/>
    </div>
  )
}

export default Rooms